import { render, staticRenderFns } from "./GlobalConfirm.vue?vue&type=template&id=2a6601f8&scoped=true&"
import script from "./GlobalConfirm.vue?vue&type=script&lang=js&"
export * from "./GlobalConfirm.vue?vue&type=script&lang=js&"
import style0 from "./GlobalConfirm.vue?vue&type=style&index=0&id=2a6601f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6601f8",
  null
  
)

export default component.exports